/* ==========================================================================
   Velora Living - theme.js
   No dependencies, no build step. Everything is either delegated from the
   document or scoped per element and safe to re-run after a section reload.
   Slider behaviour that belongs to one section lives in that section file.
   ========================================================================== */
(function () {
  'use strict';

  var theme = (window.theme = window.theme || {});
  theme.strings = theme.strings || {};
  theme.moneyFormat = theme.moneyFormat || '${{amount}}';
  theme.routes = theme.routes || {};
  theme.cartType = theme.cartType || 'drawer';
  theme.wishlistKey = theme.wishlistKey || 'velora-wishlist';

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function safeStorage(action, key, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(key);
      if (action === 'set') { window.localStorage.setItem(key, value); return true; }
      if (action === 'remove') { window.localStorage.removeItem(key); return true; }
    } catch (e) { /* private mode, blocked storage - fail quietly */ }
    return null;
  }

  /* Money formatting, used only where the browser has to build a price
     string itself. Anything rendered by Liquid keeps Liquid's formatting. */
  function formatMoney(cents, format) {
    var fmt = format || theme.moneyFormat || '${{amount}}';
    var value = typeof cents === 'string' ? cents.replace(/[^0-9.-]/g, '') : cents;
    value = Number(value) || 0;

    function pad(num, size) {
      var s = String(num);
      while (s.length < size) s = '0' + s;
      return s;
    }
    function thousands(number, sep) {
      return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
    }
    function build(precision, thousandSep, decimalSep) {
      var amount = (value / 100.0).toFixed(precision);
      var parts = amount.split('.');
      return thousands(parts[0], thousandSep) + (parts[1] ? decimalSep + pad(parts[1], precision) : '');
    }

    var out = '';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';

    switch (token) {
      case 'amount': out = build(2, ',', '.'); break;
      case 'amount_no_decimals': out = build(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = build(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = build(0, '.', ','); break;
      case 'amount_with_space_separator': out = build(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = build(0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': out = build(2, "'", '.'); break;
      default: out = build(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  theme.formatMoney = formatMoney;

  /* ---------------------------------------------------------------- toast */
  function toast(message, isError) {
    var stack = $('#toast-stack');
    if (!stack) return;
    var el = document.createElement('div');
    el.className = 'toast' + (isError ? ' toast--error' : '');
    el.setAttribute('role', 'status');
    el.textContent = message;
    stack.appendChild(el);
    setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
    }, 3000);
  }
  theme.toast = toast;

  /* -------------------------------------------------------------- drawers */
  var lastFocused = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    var overlay = $('#drawer-overlay');
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var focusable = drawer.querySelector('button, [href], input, select, textarea');
    if (focusable) focusable.focus();
  }

  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var overlay = $('#drawer-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }
  theme.openDrawer = openDrawer;
  theme.closeDrawers = closeDrawers;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      var target = openBtn.getAttribute('data-drawer-open');
      if (target === 'cart-drawer' && theme.cartType === 'page') return; // let the link through
      e.preventDefault();
      if (target === 'wishlist-drawer') renderWishlistDrawer();
      openDrawer(target);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.id === 'drawer-overlay') {
      e.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      var nav = $('#header-nav');
      if (nav && nav.classList.contains('is-open')) toggleNav(false);
      hidePredictive();
    }
  });

  /* Simple focus containment inside an open drawer. */
  document.addEventListener('focusin', function (e) {
    var open = $('.drawer.is-open');
    if (!open) return;
    if (!open.contains(e.target) && !e.target.closest('#drawer-overlay')) {
      var first = open.querySelector('button, [href], input, select, textarea');
      if (first) first.focus();
    }
  });

  /* ------------------------------------------------------------- cart API */
  function sectionsToRender() {
    var list = ['cart-drawer'];
    if (document.getElementById('shopify-section-main-cart')) list.push('main-cart');
    return list.join(',');
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var mount = document.getElementById('shopify-section-' + id);
      if (!mount) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id);
      if (fresh) mount.innerHTML = fresh.innerHTML;
    });
  }

  function refreshCartCount() {
    return fetch((theme.routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
        });
        return cart;
      })
      .catch(function () { return null; });
  }
  theme.refreshCartCount = refreshCartCount;

  function cartRequest(url, body) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  function addToCart(items, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('is-loading'); }
    return cartRequest((theme.routes.cart_add_url || '/cart/add') + '.js', { items: items })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data && res.data.description ? res.data.description : (theme.strings.error || 'Something went wrong'), true);
          return null;
        }
        applySections(res.data.sections);
        refreshCartCount();
        toast(theme.strings.added || 'Added to cart');
        if (theme.cartType === 'drawer') openDrawer('cart-drawer');
        document.dispatchEvent(new CustomEvent('velora:cart:updated'));
        return res.data;
      })
      .catch(function () { toast(theme.strings.error || 'Something went wrong', true); return null; })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('is-loading'); }
      });
  }
  theme.addToCart = addToCart;

  function changeLine(key, quantity) {
    return cartRequest((theme.routes.cart_change_url || '/cart/change') + '.js', { id: key, quantity: quantity })
      .then(function (res) {
        if (!res.ok) { toast(theme.strings.error || 'Something went wrong', true); return; }
        applySections(res.data.sections);
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('velora:cart:updated'));
      })
      .catch(function () { toast(theme.strings.error || 'Something went wrong', true); });
  }

  /* Add to cart from a product card. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    addToCart([{ id: Number(id), quantity: 1 }], btn);
  });

  /* Add to cart from the main product form. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;
    var payload = { id: Number(idInput.value), quantity: Number(qtyInput && qtyInput.value ? qtyInput.value : 1) };
    var props = {};
    $$('[name^="properties["]', form).forEach(function (input) {
      var name = input.getAttribute('name').replace('properties[', '').replace(']', '');
      if (input.value) props[name] = input.value;
    });
    if (Object.keys(props).length) payload.properties = props;
    addToCart([payload], form.querySelector('[data-add-button]'));
  });

  /* Cart line quantity + remove, inside the drawer or on the cart page. */
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0);
      return;
    }
    var step = e.target.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('[data-cart-qty]');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      var next = Number(input.value) + Number(step.getAttribute('data-cart-step'));
      if (next < 0) next = 0;
      input.value = next;
      changeLine(wrap.getAttribute('data-cart-qty'), next);
    }
  });

  document.addEventListener('change', function (e) {
    var wrap = e.target.closest('[data-cart-qty]');
    if (!wrap || e.target.tagName !== 'INPUT') return;
    var val = Number(e.target.value);
    if (isNaN(val) || val < 0) val = 0;
    changeLine(wrap.getAttribute('data-cart-qty'), val);
  });

  /* Plain quantity steppers (product page, not tied to a cart line). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var min = Number(input.getAttribute('min') || 1);
    var next = Number(input.value || min) + Number(btn.getAttribute('data-qty-step'));
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Order note on the cart page / drawer. */
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch((theme.routes.cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () {});
  });

  /* ------------------------------------------------------------- wishlist */
  function getWishlist() {
    var raw = safeStorage('get', theme.wishlistKey);
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }

  function setWishlist(list) {
    safeStorage('set', theme.wishlistKey, JSON.stringify(list));
    updateWishlistCount();
  }

  function updateWishlistCount() {
    var n = getWishlist().length;
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function syncWishlistButtons() {
    var list = getWishlist().map(function (i) { return String(i.handle); });
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(String(btn.getAttribute('data-handle'))) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    updateWishlistCount();
  }
  theme.syncWishlistButtons = syncWishlistButtons;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var list = getWishlist();
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (String(list[i].handle) === String(handle)) { idx = i; break; } }
    if (idx > -1) {
      list.splice(idx, 1);
      toast(theme.strings.wishlist_removed || 'Removed from wishlist');
    } else {
      list.push({
        handle: handle,
        title: btn.getAttribute('data-title') || handle,
        url: btn.getAttribute('data-url') || ('/products/' + handle),
        image: btn.getAttribute('data-image') || '',
        price: btn.getAttribute('data-price') || ''
      });
      toast(theme.strings.wishlist_added || 'Saved to wishlist');
    }
    setWishlist(list);
    syncWishlistButtons();
    var wd = document.getElementById('wishlist-drawer');
    if (wd && wd.classList.contains('is-open')) renderWishlistDrawer();
  });

  function renderWishlistDrawer() {
    var body = $('#wishlist-body');
    if (!body) return;
    var list = getWishlist();
    if (!list.length) {
      body.innerHTML = '<div class="empty-state"><p class="empty-state__title">' +
        (theme.strings.wishlist_empty_title || 'Your wishlist is empty') + '</p><p>' +
        (theme.strings.wishlist_empty_text || 'Tap the heart on any product to save it here.') + '</p></div>';
      return;
    }
    body.innerHTML = list.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="" width="72" height="82" loading="lazy">'
        : '';
      return '<div class="cart-line">' +
        '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
        '<div><p class="cart-line__title"><a href="' + item.url + '">' + item.title + '</a></p>' +
        '<p class="cart-line__price">' + (item.price || '') + '</p></div>' +
        '<button class="cart-line__remove" type="button" data-wishlist-remove="' + item.handle + '">' +
        (theme.strings.remove || 'Remove') + '</button></div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wishlist-remove]');
    if (!rm) return;
    e.preventDefault();
    var handle = rm.getAttribute('data-wishlist-remove');
    setWishlist(getWishlist().filter(function (i) { return String(i.handle) !== String(handle); }));
    renderWishlistDrawer();
    syncWishlistButtons();
  });

  /* ---------------------------------------------------- predictive search */
  var predictiveAbort = null;

  function hidePredictive() {
    var box = $('#predictive-results');
    if (box) { box.setAttribute('hidden', ''); box.innerHTML = ''; }
  }

  function runPredictive(term) {
    var box = $('#predictive-results');
    if (!box) return;
    if (predictiveAbort) predictiveAbort.abort();
    predictiveAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var url = (theme.routes.predictive_search_url || '/search/suggest') +
      '.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, predictiveAbort ? { signal: predictiveAbort.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          box.innerHTML = '<p class="predictive__empty">' + (theme.strings.no_results || 'No results found.') + '</p>';
          box.removeAttribute('hidden');
          return;
        }
        box.innerHTML = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="52" height="52" loading="lazy">'
            : '';
          return '<a class="predictive__item" href="' + p.url + '">' +
            '<span class="predictive__thumb">' + img + '</span>' +
            '<span><span class="predictive__title">' + p.title + '</span><br>' +
            '<span class="predictive__price">' + (p.price ? formatMoney(p.price) : '') + '</span></span></a>';
        }).join('') +
          '<a class="predictive__all" href="' + (theme.routes.search_url || '/search') +
          '?q=' + encodeURIComponent(term) + '">' + (theme.strings.view_all || 'View all results') + '</a>';
        box.removeAttribute('hidden');
      })
      .catch(function () { /* aborted or offline - leave the dropdown alone */ });
  }

  var onSearchInput = debounce(function (e) {
    var term = e.target.value.trim();
    if (term.length < 2) { hidePredictive(); return; }
    runPredictive(term);
  }, 250);

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-predictive-input]')) onSearchInput(e);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header__search')) hidePredictive();
  });

  /* ------------------------------------------------------------ mobile nav */
  function toggleNav(force) {
    var nav = $('#header-nav');
    var btn = $('#header-burger');
    if (!nav) return;
    var open = typeof force === 'boolean' ? force : !nav.classList.contains('is-open');
    nav.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#header-burger')) { e.preventDefault(); toggleNav(); }
  });

  /* ------------------------------------------------------------ back to top */
  function initBackToTop() {
    var btn = $('#to-top');
    if (!btn) return;
    var onScroll = function () { btn.classList.toggle('is-visible', window.scrollY > 500); };
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.onclick = function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    };
  }

  /* ------------------------------------------------------------------ tabs */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.tabs');
    if (!wrap) return;
    var id = btn.getAttribute('data-tab');
    $$('[data-tab]', wrap).forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
    $$('[data-tab-panel]', wrap).forEach(function (p) {
      if (p.getAttribute('data-tab-panel') === id) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
  });

  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest('[data-tab]');
    if (!btn || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var all = $$('[data-tab]', btn.closest('.tabs'));
    var i = all.indexOf(btn);
    var next = e.key === 'ArrowRight' ? (i + 1) % all.length : (i - 1 + all.length) % all.length;
    all[next].focus();
    all[next].click();
  });

  /* --------------------------------------------------------- product media */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      showMedia(thumb.closest('[data-gallery]'), thumb.getAttribute('data-gallery-thumb'));
      return;
    }
    var nav = e.target.closest('[data-gallery-nav]');
    if (nav) {
      e.preventDefault();
      var gallery = nav.closest('[data-gallery]');
      var slides = $$('[data-gallery-slide]', gallery);
      var current = 0;
      slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
      var dir = Number(nav.getAttribute('data-gallery-nav'));
      var target = (current + dir + slides.length) % slides.length;
      showMedia(gallery, slides[target].getAttribute('data-gallery-slide'));
    }
  });

  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    $$('[data-gallery-slide]', gallery).forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-gallery-slide') === mediaId);
    });
    $$('[data-gallery-thumb]', gallery).forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-gallery-thumb') === mediaId ? 'true' : 'false');
    });
  }
  theme.showMedia = showMedia;

  /* ------------------------------------------------------- variant picker */
  function initVariantPicker(root) {
    var picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function selectedOptions() {
      var values = [];
      $$('fieldset', picker).forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function matchVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== null && v.options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function markAvailability(values) {
      $$('fieldset', picker).forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var probe = values.slice();
          probe[index] = input.value;
          var candidate = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var ok = true;
            for (var j = 0; j < probe.length; j++) {
              if (probe[j] !== null && v.options[j] !== probe[j]) { ok = false; break; }
            }
            if (ok && v.available) { candidate = v; break; }
          }
          var label = input.nextElementSibling;
          if (!label) return;
          var unavailable = !candidate;
          label.classList.toggle('pill--unavailable', unavailable && label.classList.contains('pill'));
          label.classList.toggle('swatch--unavailable', unavailable && label.classList.contains('swatch'));
        });
      });
    }

    function update() {
      var values = selectedOptions();
      markAvailability(values);
      var variant = matchVariant(values);
      var idInput = root.querySelector('[data-variant-input]');
      var addBtn = root.querySelector('[data-add-button]');
      var priceEl = root.querySelector('[data-price-current]');
      var wasEl = root.querySelector('[data-price-was]');
      var offEl = root.querySelector('[data-price-off]');
      var skuEl = root.querySelector('[data-sku]');
      var stockEl = root.querySelector('[data-stock]');

      $$('[data-option-selected]', picker).forEach(function (el, index) {
        el.textContent = values[index] || '';
      });

      if (!variant) {
        if (addBtn) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = theme.strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      if (wasEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          wasEl.innerHTML = formatMoney(variant.compare_at_price);
          wasEl.removeAttribute('hidden');
          if (offEl) {
            var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            offEl.textContent = pct + '% off';
            offEl.removeAttribute('hidden');
          }
        } else {
          wasEl.setAttribute('hidden', '');
          if (offEl) offEl.setAttribute('hidden', '');
        }
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (stockEl) {
        stockEl.textContent = variant.available ? (theme.strings.in_stock || 'In stock') : (theme.strings.out_of_stock || 'Out of stock');
        stockEl.classList.toggle('product__stock--out', !variant.available);
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = theme.strings.add_to_cart || 'Add to cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = theme.strings.sold_out || 'Sold out';
        }
      }
      if (variant.featured_media_id) {
        showMedia(root.querySelector('[data-gallery]'), String(variant.featured_media_id));
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  }

  /* ------------------------------------------------- product recommendations */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.getAttribute('data-loaded') === 'true') return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      el.setAttribute('data-loaded', 'true');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (!fresh || !fresh.querySelector('.product-card')) {
            var wrapper = el.closest('[data-recommendations-section]');
            if (wrapper) wrapper.remove();
            return;
          }
          el.innerHTML = fresh.innerHTML;
          syncWishlistButtons();
          initRows(el.closest('[data-recommendations-section]') || document);
        })
        .catch(function () {
          var wrapper = el.closest('[data-recommendations-section]');
          if (wrapper) wrapper.remove();
        });
    });
  }

  /* --------------------------------------------- one-row product carousels */
  function animateScroll(track, target, done) {
    var start = track.scrollLeft;
    var delta = target - start;
    var duration = 380;
    var startTime = null;
    var finished = false;

    // scroll-snap: mandatory fights native smooth scrolling, so the position is
    // animated by hand with snapping suspended for the duration.
    var previousSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';

    function finish() {
      if (finished) return;
      finished = true;
      track.scrollLeft = target;
      track.style.scrollSnapType = previousSnap;
      if (done) done();
    }

    function step(now) {
      if (finished) return;
      if (startTime === null) startTime = now;
      var t = Math.min(1, (now - startTime) / duration);
      var eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      track.scrollLeft = start + delta * eased;
      if (t < 1) { window.requestAnimationFrame(step); } else { finish(); }
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
    window.requestAnimationFrame(step);
    // Background tabs and some in-app browsers never deliver animation frames.
    setTimeout(finish, duration + 220);
  }
  theme.animateScroll = animateScroll;

  function initRows(scope) {
    $$('[data-prow]', scope || document).forEach(function (row) {
      if (row.getAttribute('data-prow-ready') === 'true') return;
      row.setAttribute('data-prow-ready', 'true');
      var track = row.querySelector('[data-prow-track]');
      var prev = row.querySelector('[data-prow-prev]');
      var next = row.querySelector('[data-prow-next]');
      if (!track) return;

      function stepSize() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
        return first.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) { if (track.scrollLeft <= 2) { prev.setAttribute('disabled', ''); } else { prev.removeAttribute('disabled'); } }
        if (next) { if (track.scrollLeft >= max) { next.setAttribute('disabled', ''); } else { next.removeAttribute('disabled'); } }
      }

      function go(dir) {
        var max = track.scrollWidth - track.clientWidth;
        var target = track.scrollLeft + dir * stepSize() * 2;
        if (target < 0) target = 0;
        if (target > max) target = max;
        animateScroll(track, target, updateButtons);
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', debounce(updateButtons, 80), { passive: true });
      window.addEventListener('resize', debounce(updateButtons, 150));
      updateButtons();
    });
  }
  theme.initRows = initRows;

  /* ------------------------------------------------------- collection page */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-facets-toggle]')) {
      e.preventDefault();
      var sidebar = $('#collection-sidebar');
      if (sidebar) sidebar.classList.toggle('is-open');
    }
  });

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facet-form]');
    if (form && e.target.type === 'checkbox') form.submit();
    var sort = e.target.closest('[data-sort-select]');
    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* ------------------------------------------------------------------ init */
  function init(scope) {
    var root = scope || document;
    initRows(root);
    $$('[data-product-root]', root).forEach(initVariantPicker);
    if (root === document) {
      initBackToTop();
      initRecommendations();
    }
    syncWishlistButtons();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id === 'shopify-section-cart-drawer') openDrawer('cart-drawer');
  });
  document.addEventListener('velora:cart:updated', function () { syncWishlistButtons(); });
})();
